import React from "react";
import { useI18n } from "../../../hooks/useI18n";
import FormFieldGroup from "../FormFieldGroup";
import { getEngagementMasterFormFields } from "../EnagementMasterData";
import "../EngagementMaster.scss";

const EngagementMasterTab = ({ data = {} }) => {
  const { t } = useI18n();

  const formFields = getEngagementMasterFormFields(t, data);

  return (
    <div className="engagement-master-tab">
      <div className="form-container">
        {formFields.map((fieldRow, index) => (
          <div key={index} className="form-row">
            {fieldRow.row.map((field, fieldIndex) => (
              <FormFieldGroup
                key={fieldIndex}
                label={field.label}
                value={field.value}
                gridClass={field.gridClass}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default EngagementMasterTab;
